// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"71":"localeUA","960":"localeEN"}[chunkId] + "." + {"71":"148cf99d55ce61ae0ee8","960":"6d0b5f5e1d9d806059cc"}[chunkId] + ".bundle.js";
};